import React, { forwardRef, useEffect, useState } from 'react';

import { IInputProps, Input } from '../Input';

export interface INumberInputProps extends Omit<IInputProps, 'type' | 'onChange'> {
    onChange?: (value: number | undefined) => void;
}

export const NumberInput = forwardRef<HTMLInputElement, INumberInputProps>(
    ({ onChange, value: valueControlled, ...props }, ref) => {
        const [shownValue, setShownValue] = useState('');

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            let value = e.currentTarget.value;
            value = value.replace(/[^0-9.,]/g, '');
            setShownValue(value);

            if (value === '') {
                return onChange?.(undefined);
            }

            const transformedValue = value.replace(/,/g, '.');
            if (transformedValue === '.') {
                return;
            }
            
            const valueAsNumber = Number(value.replace(/,/g, '.'));
            onChange?.(valueAsNumber);
        };

        useEffect(() => {
            if (valueControlled === undefined) {
                setShownValue('');
            } else {
                setShownValue(valueControlled.toString());
            }
        }, [valueControlled]);

        return <Input type="number" value={shownValue} onChange={handleChange} {...props} ref={ref} />;
    },
);
